import { flatMap } from "lodash"
import { MESSAGE_ROLES } from "../helpers/constants"

/**
 * Process paginated messages into a flat list for rendering
 * Returns only the messages that have been fetched (no placeholders)
 */
export function buildMessageList(paginatedData) {
  if (!paginatedData?.pages?.length) {
    return []
  }

  // When retrieving messages from the API, the pages are reversed, so we need to reverse them back
  // to get the messages in the correct order (oldest to newest)
  return flatMap([...paginatedData.pages].reverse(), "messages")
}

/**
 * Find the last assistant message ID in a list of messages
 */
export function findLastAssistantMessageId(messages) {
  return messages.findLast(msg => msg.role === MESSAGE_ROLES.ASSISTANT)?.id
}
